module.exports = __webpack_public_path__ + "img/show_tc_text_2.13d6d2bb.png";